import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SnackbarService } from './../../snackbar/snackbar.service';
import { AuthService, AuthorizationService, CartService } from './../../../../core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
interface Metadata {
  access?: boolean;
  action?: string;
  shipping?: number;
  previous?: number;
}
@Component({
  standalone: false,
  selector: 'app-edit-shipping',
  templateUrl: './edit-shipping.component.html',
  styleUrls: ['./edit-shipping.component.scss']
})
export class EditShippingComponent implements OnInit {
  public myForm: FormGroup;
  isAuthorization = false;
  public currency;
  actions = [
    { id: 'updateShipping', value: 'Modificar' },
    { id: 'deleteShipping', value: 'Eliminar' }
  ];
  complete = false;
  stateAction = '';
  previousPrice: any;
  constructor(
    public cartService: CartService,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EditShippingComponent>,
    public authorizationService: AuthorizationService,
    public snackbarService: SnackbarService,
    public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public metadata: Metadata // de tipo datareferencia
  ) {
    this.myForm = formBuilder.group({
      action: ['updateShipping'],
      user: [null],
      password: [null],
      shipping: [1],
      access: [false],
    });
  }

  ngOnInit() {
    this.currency = this.authService.getUser().currencyCode;
    this.previousPrice = this.metadata.shipping;
    this.initialize(this.metadata);
    this.myForm.controls['action'].valueChanges.subscribe(item => {
      this.getStateModal();
      this.setValidate(item);
    });
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  initialize(data) {
    this.isAuthorization = data.access ? true : false;
    this.myForm.controls['shipping'].setValue(data.shipping ? data.shipping : null);
    this.myForm.controls['action'].setValue(data.action ? data.action : 'updateShipping');
    this.myForm.controls['access'].setValue(data.access ? data.access : null);
    this.getStateModal();
    this.setValidate(this.myForm.controls['action'].value);
  }

  setValidate(item) {
    if (item) {
      this.myForm.controls['shipping'].setValidators([Validators.required, Validators.min(0.01), Validators.max(999)]);
      this.myForm.controls['shipping'].updateValueAndValidity();
    } else {
      this.myForm.controls['shipping'].clearValidators();
      this.myForm.controls['shipping'].updateValueAndValidity();
    }
  }

  submit(): void {
    switch (this.stateAction) {
      case 'AM':
        if (this.myForm.valid) {
          this.dialogRef.close(this.myForm.value);
        } else {
          this.snackbarService.show('formRequired', 'warning');
        }
        break;
      case 'AE':
        this.myForm.controls['shipping'].setValue(0.01);
        this.dialogRef.close(this.myForm.value);
        break;
    }
  }

  getStateModal() {
    this.stateAction = this.isAuthorization ?
      this.myForm.controls['action'].value === 'updateShipping' ? 'AM'
        : 'AE'
      : 'SA';
  }
  round(event) {
    const key = window.event ? event.which : event.charCode;
    const value = event.key;
    if (key === 46) {
      event.preventDefault();
    }
  }
}
